// src/Models/projectTeamMemberModel.js
// -----------------------------------------------------------------------------
// Model class to transform properties between C# backend schema (camelCase/PascalCase)
// and the React frontend UI scheme (casing suffixes like ID).
// -----------------------------------------------------------------------------

export class ProjectTeamMemberModel {
  static toFrontend(data) {
    if (!data) return null;
    return {
      teamMemberID: data.teamMemberId || data.teamMemberID,
      teamID: data.teamId || data.teamID,
      userID: data.userId || data.userID,
      projectRoleID: data.projectRoleId || data.projectRoleID,
      addedDttm: data.addedDttm,
    };
  }

  static toBackend(data) {
    if (!data) return null;
    return {
      teamMemberId: Number(data.teamMemberID || data.teamMemberId || 0),
      teamId: Number(data.teamID || data.teamId || 0),
      userId: Number(data.userID || data.userId || 0),
      projectRoleId: Number(data.projectRoleID || data.projectRoleId || 0),
    };
  }
}
